import HistoricalBankData from "../components/HistoricalBankData/HistoricalBankData";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import { All, SortDirection } from "../interfaces";
import { updateSortOrder } from "../common/actions";

function mapStateToProps({ appState }: All) {
  return {
    appState: appState.historical,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateEndDate: (year: string) => {
      dispatch(actions.updateFilter("endDate", year));
    },
    updateSort: (sortField: string, sortDirection: SortDirection) => {
      dispatch(updateSortOrder(sortField, sortDirection));
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(HistoricalBankData);
